(() => {
  if (customElements.get('products-carousel')) {
    return;
  }

  class ProductsCarousel extends HTMLElement {
    constructor() {
      super();

      this.swiper = null;
      this.cardsSize = this.dataset.cardsSize || 'default';
      this.shouldDestroyOnDesktop = this.hasAttribute('data-destroy');
      this.breakpoints = {
        desktop: 990
      };
    }

    connectedCallback() {
      this.initSwiper();
      this.toggleSwiperHandler();
      window.addEventListener('resize', debounce(this.toggleSwiperHandler.bind(this), 500));
    }

    initSwiper() {
      const swiperContainer = this.querySelector('.products-carousel__slider');

      const swiperNext = this.querySelector('.products-carousel__control-next');
      const swiperPrev = this.querySelector('.products-carousel__control-prev');

      const sizeCardSettings = {
        default: {
          slidesPerView: 1.2,
          spaceBetween: 32,
          breakpoints: {
            [this.breakpoints.desktop]: {
              slidesPerView: 2.75,
              spaceBetween: 48,
            },
          },
        },
        large: {
          slidesPerView: 1.1,
          spaceBetween: 24,
          breakpoints: {
            [this.breakpoints.desktop]: {
              slidesPerView: 3.2,
              spaceBetween: 24,
            },
          },
        },
      };


      if (!swiperContainer) return;

      const mainSettings = {
        navigation: {
          nextEl: swiperNext,
          prevEl: swiperPrev,
        },
        speed: 300,
        watchOverflow: true,
        ...sizeCardSettings[this.cardsSize]
      };

      if (this.tagName === 'PRODUCT-RECOMMENDATIONS' || this.hasAttribute('data-all-products')) {
        mainSettings.slidesPerView = 2;
        mainSettings.spaceBetween = 12;
        mainSettings.watchOverflow = true;
        mainSettings.breakpoints = {
          750: {
            slidesPerView: 3,
            spaceBetween: 20,
          },
          [this.breakpoints.desktop]: {
            slidesPerView: 5,
            spaceBetween: 24,
          },
        };
      }

      const sectionId = this.closest('.shopify-section')?.id || '';

      if (sectionId.endsWith('__16451933041de5290d')) {
        mainSettings.breakpoints = {
          ...mainSettings.breakpoints,
          [this.breakpoints.desktop]: {
            ...mainSettings.breakpoints?.[this.breakpoints.desktop],
            slidesPerView: 5,
            spaceBetween: 24,
          },
        };
      }

      if (sectionId.endsWith('__featured_products_qbUwG3')) {
        mainSettings.navigation = false;
        mainSettings.watchOverflow = true;
        mainSettings.breakpoints = {
          ...mainSettings.breakpoints,
          [this.breakpoints.desktop]: {
            ...mainSettings.breakpoints?.[this.breakpoints.desktop],
            slidesPerView: 2,
            spaceBetween: 24,
            allowTouchMove: false,
          },
        };
      }

      if (
        sectionId.endsWith('__16451933041de5290d') ||
        sectionId.endsWith('__featured_products_qbUwG3')
      ) {
        mainSettings.breakpoints = {
          0: {
            slidesPerView: 2,
            spaceBetween: 12,
          },
          750: {
            slidesPerView: mainSettings.slidesPerView,
            spaceBetween: mainSettings.spaceBetween,
          },
          ...mainSettings.breakpoints,
        };
      }

      this.swiper = new Swiper(swiperContainer, mainSettings);
    }

    toggleSwiperHandler() {
      if (!this.shouldDestroyOnDesktop) return;
      try {
        this.toggleSwiper(window.innerWidth >= this.breakpoints.desktop);
      } catch(e) {}
    }

    toggleSwiper(destroy) {
      if (destroy) {
        this.swiper.destroy(true, true);
      } else {
        this.swiper = new Swiper(swiperContainer, mainSettings);
      }
    }
  }

  customElements.define('products-carousel', ProductsCarousel);
})();
